import { Button, Checkbox, Modal } from "antd";

export default function DeleteSubscriptionRecord({ props }) {
  return (
    <Modal
      visible={props.deleteVisible}
      title="Delete this subscription?"
      onCancel={props.toggleDeletePopup}
      footer={[
        <Button key="Back" onClick={props.toggleDeletePopup}>
          Return
        </Button>,
        <Button
          type="danger"
          key="Delete"
          className={"btn btn-success"}
          loading={props.loading}
          onClick={props.hardDelete}
        >
          Permanent Delete
        </Button>,
      ]}
    >
      <div className="p-2">Subscription: {props.subscriptionData.id}</div>

      <div className="p-2-small-text">
        <ul>
          <li>
            <p>
              {props.subscriptionData.access_group?.name}
            </p>
          </li>
        </ul>
      </div>

      <div className="p-2">
        <strong>Check all</strong> the items below to confirm subscription record
        deletion, Deleting a subscription record is permanent and <strong>cannot</strong> be undone
      </div>

      <div className="frame-detail">
        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox1(value.target.checked);
            }}
            checked={props.checkBox1}
          >
            Any future access of the data will be impossible
          </Checkbox>
        </div>

        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox2(value.target.checked);
            }}
            checked={props.checkBox2}
          >
            User <strong>{props.subscriptionData.user?.email}</strong> will not
            be able to futher acess to the course content
          </Checkbox>
        </div>
      </div>
    </Modal>
  );
}
